// extracted by mini-css-extract-plugin
export default {"EmptyProjectTemplateTasksList":"EmptyProjectTemplateTasksList_EmptyProjectTemplateTasksList__xscCK"};